$('.prod-desc-toggle').click(function(){
  $(this).parent().toggleClass("short");
});

$('.product-description').each(function (){
  var charLength = $(this).find('p').text().length;
 if(charLength < 475) {
   $(this).find('.prod-desc-toggle').hide();
 }
});

$('.home-featured-gallery ul').flickity({
  // options
  contain: true,
  pageDots: false,
  freeScroll: true,
  wrapAround: true
});
